module.exports = __webpack_public_path__ + "img/6.a94586c.svg";